/**
 * Keep Vite's import.meta.env access separate so Jest can replace this module.
 */
interface AppRedirectEnv {
  /** An empty string uses the page origin; undefined means no service is configured. */
  apiBaseUrl?: string;
}

export function getAppRedirectEnv(): AppRedirectEnv {
  const env = import.meta.env;

  // The local inspector uses Vite's proxy. Connected ACUL serves a build
  // and uses the configured service URL below.
  if (env?.DEV === true) {
    return { apiBaseUrl: "" };
  }

  return {
    apiBaseUrl: env?.VITE_EMAIL_VERIFICATION_SERVICE_URL,
  };
}
